import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionSetPaymentEntryInfo, TypeActionPaymentEntryInfo, } from "./actionPaymentEntryInfo";
export var epicPaymentEntryInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPaymentEntryInfo.RequestPaymentEntryInfo), switchMap(function (action) {
        var playerId = selectOwnPlayerId(state$.value);
        return deps.netSend({
            id: CommandCode.PaymentEntryInfo,
            props: {
                offerCharacteristicId: action.ids,
                playerId: playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        return res.offers &&
            res.offers.some(function (offer) {
                return offer.amount != undefined && offer.amount.isZero && !offer.amount.isZero();
            })
            ? of(actionSetPaymentEntryInfo(res.offers))
            : EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/payment-entry-info/epicPaymentEntryInfo.ts
// module id = 1925
// module chunks = 3